import React from "react";
import "./Advantages.css";
import advantage1 from "../../assets/advantages/advantage1.svg";
import advantage2 from "../../assets/advantages/advantage2.svg";
import advantage3 from "../../assets/advantages/advantage3.svg";
import advantage4 from "../../assets/advantages/advantage4.svg";
import advantage5 from "../../assets/advantages/advantage5.svg";

const advantages = [
    { id: 1, image: advantage1, text: "Лучшие цены на рынке" },
    { id: 2, image: advantage2, text: "Высокое качество товаров" },
    { id: 3, image: advantage3, text: "Среднее время обмена до 2 часов" },
    { id: 4, image: advantage4, text: "Высокие лимиты обмена" },
    { id: 5, image: advantage5, text: "Поддержка в чате с 9:00 до 18:30 (UTC +1)" },
];

const Advantages = () => {
    return (
        <section className="advantages-section">
            <div className="advantages-container">
                {advantages.map((adv) => (
                    <div key={adv.id} className="advantage-card ">
                        <div className="advantage-image">
                            <img src={adv.image} alt="advantage" />
                        </div>
                        <span className="advantage-text">{adv.text}</span>
                    </div>
                ))}
            </div>
        </section>
    );
};

export default Advantages;
